export const handleGetNestedProperty = (obj, propertyString: string) => {
  const properties = propertyString.split('.');
  let currentObj = obj;

  for (let i = 0; i < properties.length; i++) {
    if (currentObj[properties[i]] !== undefined) currentObj = currentObj[properties[i]];
    else return undefined;
  }

  return currentObj;
};
